import BaseService from '@/services/BaseService'

class CargoService extends BaseService {
    constructor(){
        super('/v1/cargos')
    }
}

export default new CargoService